module.exports = __webpack_public_path__ + "static/img/zhfk_17.a3c1366.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/zhfk_17.png
// module id = Hjwm
// module chunks = 1